import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, tap, takeUntil, startWith } from 'rxjs/operators';

@Component({
  selector: 'ma-bootstrap-modal',
  templateUrl: './bootstrap-modal.component.html',
  styleUrls: ['./bootstrap-modal.component.scss'],
})
export class BootstrapModalComponent implements OnDestroy, AfterViewInit {
  @ViewChild('accountId', { static: true }) accountIdInput: ElementRef<
    HTMLInputElement
  >;
  @ViewChild('sectionId', { static: true }) sectionIdInput: ElementRef<
    HTMLInputElement
  >;
  @ViewChild('bootstrapButton', { static: true }) bootstrapButton: ElementRef<
    HTMLButtonElement
  >;

  destroy$ = new Subject();

  constructor(public activeModal: NgbActiveModal) {}

  bootstrap$ = new Subject<{ accountId: string; sectionId: string }>();
  isBootstrapping$ = new Subject<boolean>();
  bootstrapButtonText$ = this.isBootstrapping$.pipe(
    map((isBootstrapping) => (isBootstrapping ? 'Loading...' : 'Bootstrap')),
    startWith('Bootstrap'),
  );

  setLoadingState(isLoading: boolean) {
    this.accountIdInput.nativeElement.disabled = isLoading;
    this.sectionIdInput.nativeElement.disabled = isLoading;
    this.bootstrapButton.nativeElement.disabled = isLoading;
  }

  bootstrap() {
    const accountId = this.accountIdInput.nativeElement.value;
    const sectionId = this.sectionIdInput.nativeElement.value;
    this.bootstrap$.next({ accountId, sectionId });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngAfterViewInit() {
    this.isBootstrapping$
      .pipe(
        takeUntil(this.destroy$),
        tap((isLoading) => this.setLoadingState(isLoading)),
      )
      .subscribe();

    this.bootstrap$
      .pipe(tap(() => this.isBootstrapping$.next(true)))
      .subscribe();
  }
}
